import script from "./DiamondInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./DiamondInfo.vue?vue&type=script&setup=true&lang=ts"

import "./DiamondInfo.vue?vue&type=style&index=0&id=a311c138&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a311c138"]])

export default __exports__